import script from "./myCartPage2.vue?vue&type=script&setup=true&lang=js"
export * from "./myCartPage2.vue?vue&type=script&setup=true&lang=js"

import "./myCartPage2.vue?vue&type=style&index=0&id=1f1ea6dc&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f1ea6dc"]])

export default __exports__